"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../lib/utils.js");

var _useMentions2 = _interopRequireDefault(require("../../hooks/useMentions"));

var _SuggestionsList = _interopRequireDefault(require("./SuggestionsList"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Mentions = /*#__PURE__*/_react.default.memo( /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMentions = _useState2[0],
      setShowMentions = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedSuggestionIndex = _useState4[0],
      setSelectedSuggestionIndex = _useState4[1];

  var cursorIndex = props.cursorIndex,
      defaultMentions = props.defaultMentions,
      keyPress = props.keyPress,
      onAcceptedSuggestionsChange = props.onAcceptedSuggestionsChange,
      onChange = props.onChange,
      onTextValueChange = props.onTextValueChange,
      textValue = props.textValue; // Here's the useMentions hook, which provides data and methods for fetching data

  var _useMentions = (0, _useMentions2.default)(defaultMentions),
      getSuggestionsFromInput = _useMentions.getSuggestionsFromInput,
      suggestions = _useMentions.suggestions,
      acceptedSuggestions = _useMentions.acceptedSuggestions,
      acceptSuggestion = _useMentions.acceptSuggestion; // Update the host if


  (0, _react.useEffect)(function () {
    onAcceptedSuggestionsChange(acceptedSuggestions);
  }, [onAcceptedSuggestionsChange, acceptedSuggestions]);
  (0, _react.useEffect)(function () {
    var willFetch = getSuggestionsFromInput(textValue, cursorIndex); // If we are fetching, hide the list.  Otherwise keep showing.

    setShowMentions(willFetch); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textValue, cursorIndex]); // Disabled exhaustive-deps so getSuggestionsFromInput dependency doesn't cause infinite loop
  // Expose showMentions for TextareaInput to decide what to do with Enter key press

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getShowMentions: function getShowMentions() {
        return showMentions;
      }
    };
  }, [showMentions]); // Set up handler for clicking a suggestion

  var handleSuggestionClick = (0, _react.useCallback)(function (index) {
    var selectedUser = suggestions[(0, _utils.normalizeIndex)(index || selectedSuggestionIndex, suggestions.length)];

    if (selectedUser) {
      acceptSuggestion(selectedUser).then(function () {
        setShowMentions(false);
        setSelectedSuggestionIndex(0);
        var textBeforeCursor = textValue.substring(0, cursorIndex);
        var lastMentionIndex = (0, _utils.lastIndexOfRegex)(textBeforeCursor, _constants.MENTION_REGEX); // Replace the mention query text with the accepted user

        var updatedTextValue = // eslint-disable-next-line prefer-template
        textValue.substring(0, lastMentionIndex + 1) + // Text up to and including the @ mention
        selectedUser.name + // Accepted user name
        ' ' + // Give a space after the inserted name
        textValue.substring(cursorIndex); // Text after the @ mention query text
        // Cursor index logic: @ symbol location + 1 to get past @ + suggestion name + 1 for a space after the name

        var newCursorIdx = lastMentionIndex + 1 + selectedUser.name.length + 1;
        onTextValueChange(updatedTextValue, newCursorIdx);
      });
    }
  }, [acceptSuggestion, selectedSuggestionIndex, cursorIndex, onTextValueChange, suggestions, textValue]); // Handle key presses for moving through list and selecting suggestions

  (0, _react.useEffect)(function () {
    if (!showMentions) return;

    switch (keyPress.keyCode) {
      case _constants.KEY_CODES.ENTER:
      case _constants.KEY_CODES.TAB:
        // Accept the currently selected suggestion
        handleSuggestionClick(); // Hide the mentions list

        setShowMentions(false);
        break;

      case _constants.KEY_CODES.UP:
        // Move up the suggestions list
        setSelectedSuggestionIndex(function (suggestionIndex) {
          return (0, _utils.normalizeIndex)(suggestionIndex - 1, suggestions.length);
        });
        break;

      case _constants.KEY_CODES.DOWN:
        // Move down the suggestions list
        setSelectedSuggestionIndex(function (suggestionIndex) {
          return (0, _utils.normalizeIndex)(suggestionIndex + 1, suggestions.length);
        });
        break;

      case _constants.KEY_CODES.ESCAPE:
        // Hide the mentions list
        setShowMentions(false);
        break;

      default:
        // Do nothing - unexpected key passed
        break;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [keyPress]); // Disabled exhaustive-deps because including handleSuggestionClick or showMentions causes the useEffect to fire incorrectly

  (0, _react.useEffect)(function () {
    if (showMentions) {
      onChange(selectedSuggestionIndex);
    } else {
      onChange(-1);
    }
  }, [onChange, selectedSuggestionIndex, showMentions]);
  return suggestions.length > 0 && showMentions ? /*#__PURE__*/_react.default.createElement(_SuggestionsList.default, {
    onUserCardClick: handleSuggestionClick,
    onUserCardHover: setSelectedSuggestionIndex,
    selectedIndex: (0, _utils.normalizeIndex)(selectedSuggestionIndex, suggestions.length),
    suggestions: suggestions
  }) : null;
}));

Mentions.displayName = 'Mentions';
Mentions.propTypes = {
  cursorIndex: _propTypes.default.number,
  defaultMentions: _propTypes.default.array,
  keyPress: _propTypes.default.object,
  onAcceptedSuggestionsChange: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onTextValueChange: _propTypes.default.func,
  textValue: _propTypes.default.string
};
Mentions.defaultProps = {
  cursorIndex: 0,
  defaultMentions: [],
  keyPress: {},
  onAcceptedSuggestionsChange: function onAcceptedSuggestionsChange() {},
  onChange: function onChange() {},
  onTextValueChange: function onTextValueChange() {},
  textValue: ''
};
var _default = Mentions;
exports.default = _default;